import map from "ramda/es/map";
import keyMirror from "ramda-extension/es/keyMirror";
export const CONTENT_TYPE = {
    APPLICATION_X_WWW_FORM_URLENCODED: 'application/x-www-form-urlencoded',
    APPLICATION_JSON: 'application/json',
    MULTIPART_FORM_DATA: 'multipart/form-data',
    TEXT_HTML: 'text/html',
    IMAGE_PNG: 'image/png',
    APPLICATION_PDF: 'application/pdf',
    AUDIO_MPEG3: 'audio/mpeg3',
    VIDEO_MP4: 'video/mp4'
};
export const METHOD = keyMirror({
    POST: null,
    GET: null,
    PUT: null,
    DELETE: null,
    PATCH: null,
    HEAD: null,
    OPTIONS: null
});
export const CONTENT_TYPE_HEADER_KEY = 'Content-Type';
export const CONTENT_TYPE_HEADER = map((value)=>({
        [CONTENT_TYPE_HEADER_KEY]: value
    }), CONTENT_TYPE);
export const X_CSRF_TOKEN = 'X-CSRF-TOKEN';
export const OAUTH_HEADER_NAME = 'Authorization';
export const AUTH_HEADER_NAME = 'X-Authorization';
export const AUTH_SCHEMA_BEARER = 'Bearer';
export const CALL_API = Symbol('Call API');
export const IN_PROGRESS_HTTP_STATUS = 202;
export const NOT_PROVIDED = 'not provided';
// Bifrost logout URL
export const LOGOUT_URL_CONTEXT = '/logout';
